// import { Controller } from "@hotwired/stimulus"
// import { useClickOutside, useIntersection, useTransition } from 'stimulus-use'
// import { useTransition } from 'stimulus-use'
import axios from "axios"
import DropdownController from "./dropdown_controller"
import { createPopper } from "@popperjs/core"
const debounce = require("lodash/debounce")
// import { IntersectionController } from 'stimulus-use'
// import { useTransition } from 'stimulus-use/dist/use-transition'

/* przykład użycia: app/views/design/uix/stimulus.html.erb */

export default class extends DropdownController {
  static targets = ["menu", "input", "list", "searchWait"]
  static values = { position: String }

  eventCreated = false
  useNone = false
  menuHidden = false

  connect() {
    console.log("connect1")
    // useIntersection(this)
    // useClickOutside(this)
    // this.menuTarget.classList.add('hidden')
    this.useNone = this.menuTarget.dataset.useNone === "true"
    // this.element.textContent = "Hello World from Stimulus1! Dropdown"

    // useTransition(this, { element: this.menuTarget })
    super.connect()

    this.updateSearchDebounce = debounce(this.updateSearchDebounce, 1000).bind(this)
  }

  fillDropdown(event) {
    // select_id powinien miec format "new_ID_SELECTA_Z_FORMULARZA", wtedy tym dropdownem mozemy wypelnic wlasciwy select w formularzu
    let selectId = event.params.select
    console.log(event.params.select)
    let chosenId = event.params.id
    // chosenId = !Number.isInteger(chosenId) ? '0' : chosenId
    const headerAvatar = document.getElementById(selectId + "_avatar")
    const headerName = document.getElementById(selectId + "_name")
    const selectedAvatar = document.getElementById(selectId + "_avatar_" + chosenId)
    const selectedName = document.getElementById(selectId + "_name_" + chosenId)

    selectId = selectId.split("new_")[1]
    const selectElement = document.getElementById(selectId)

    if (headerName !== null && selectedName !== null) {
      headerName.innerHTML = selectedName.innerText
    }

    if (headerAvatar) {
      if (selectedAvatar) {
        headerAvatar.innerHTML = selectedAvatar.innerHTML
      } else {
        headerAvatar.innerHTML = ""
      }
    }
    chosenId = chosenId === 0 || chosenId === "none" ? "" : chosenId
    if (chosenId === "" && this.useNone) {
      chosenId = "none"
    }
    console.log(chosenId)
    console.log(selectId)
    selectElement.value = chosenId

    // użyte po to by input wywołał akcje na onchange jeśli została podana
    selectElement.dispatchEvent(new Event("change"))
    this.toggle()
  }

  updateSearchInfoShow() {
    this.searchWaitTarget.classList.remove("hidden")
    this.searchWaitTarget.classList.add("block")
  }

  updateSearchInfoHide() {
    this.searchWaitTarget.classList.add("hidden")
    this.searchWaitTarget.classList.remove("block")
  }

  updateSearch(event) {
    this.updateSearchInfoShow()
    this.updateSearchDebounce(event)
  }

  updateSearchDebounce(event) {
    console.log("update")
    const input = this.inputTarget.value
    const url = this.inputTarget.dataset.url
    console.log(encodeURIComponent(input))

    event.preventDefault()

    axios.get(url, {
      params: {
        query: encodeURIComponent(input)
      },
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest"
      }
    })
      .then((response) => {
        console.log("update success")

        const script = document.createElement("script")
        script.textContent = response.data
        console.log(response)
        console.log(script.textContent)
        document.body.appendChild(script)
        document.body.removeChild(script)
        this.updateSearchInfoHide()
        // this.announceChangedSectionToScreenReader()
      })
      .catch((error) => {
        console.log("error updating", error)
        this.updateSearchInfoHide()
      })
  }

  attachPopper() {
    if (this.hasPositionValue) {
      console.log("hasPositionValue", this.positionValue)
      this.popper = createPopper(this.element, this.menuTarget, {
        placement: this.positionValue,
        modifiers: [
          {
            name: "flip",
            options: {
              fallbackPlacements: ["top", "left", "bottom", "right"],
              offset: [0, 0],
            },
          },
        ],
      })
      console.log("poper", this.popper)
    }
  }
}
